import { SvgIcons } from 'common/consts/svgIcons';
import { ReactComponent as TooltipIcon } from 'common/icons/tooltip-icon.svg';
import { ReactComponent as CalendarIcon } from 'common/icons/calendar-icon.svg';
import { ReactComponent as ConfirmationIcon } from 'common/icons/confirmation-icon.svg';
import { ReactComponent as CloseIcon } from 'common/icons/close-icon.svg';
import { ReactComponent as PrinterIcon } from 'common/icons/printer-icon.svg';
import { ReactComponent as PdfIcon } from 'common/icons/pdf-icon.svg';
import { ReactComponent as ShowPasswordIcon } from 'common/icons/show-pass-icon.svg';
import { ReactComponent as HidePasswordIcon } from 'common/icons/hide-pass-icon.svg';
import { ReactComponent as ChevronIcon } from 'common/icons/chevron-icon.svg';
import { ReactComponent as SuccessIcon } from 'common/icons/state-success-icon.svg';
import { ReactComponent as ErrorIcon } from 'common/icons/state-error-icon.svg';
import { ReactComponent as InfoIcon } from 'common/icons/state-info-icon.svg';

export const IconsMap = new Map()
  .set(SvgIcons.TOOLTIP, TooltipIcon)
  .set(SvgIcons.CALENDAR, CalendarIcon)
  .set(SvgIcons.CONFIRMATION, ConfirmationIcon)
  .set(SvgIcons.CLOSE, CloseIcon)
  .set(SvgIcons.PRINTER, PrinterIcon)
  .set(SvgIcons.PDF, PdfIcon)
  .set(SvgIcons.HIDE_PASSWORD, ShowPasswordIcon)
  .set(SvgIcons.SHOW_PASSWORD, HidePasswordIcon)
  .set(SvgIcons.CHEVRON_ICON, ChevronIcon)
  .set(SvgIcons.SUCCESS, SuccessIcon)
  .set(SvgIcons.ERROR, ErrorIcon)
  .set(SvgIcons.INFO, InfoIcon);
